import React, { useState } from 'react';

function StepSeven({ formData, onNext }) {
    const [hasWorkLimitingCondition, setHasWorkLimitingCondition] = useState(formData.hasWorkLimitingCondition || '');
    const [workConditionDetails, setWorkConditionDetails] = useState(formData.workConditionDetails || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!hasWorkLimitingCondition) {
            setError('Please select Yes or No.');
            return;
        }

        if (hasWorkLimitingCondition === 'yes' && !workConditionDetails.trim()) {
            setError('Please explain the condition that may affect your ability to perform the role.');
            return;
        }

        setError('');
        onNext({ hasWorkLimitingCondition, workConditionDetails });
    };

    const isFormValid =
        hasWorkLimitingCondition === 'no' ||
        (hasWorkLimitingCondition === 'yes' && workConditionDetails.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">Work-Related Health</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Do you have any condition that may affect your ability to perform the role you are employed to do? <span className="text-danger">*</span></p>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="workLimitingCondition"
                            id="workConditionYes"
                            value="yes"
                            checked={hasWorkLimitingCondition === 'yes'}
                            onChange={() => setHasWorkLimitingCondition('yes')}
                        />
                        <label className="form-check-label" htmlFor="workConditionYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="workLimitingCondition"
                            id="workConditionNo"
                            value="no"
                            checked={hasWorkLimitingCondition === 'no'}
                            onChange={() => setHasWorkLimitingCondition('no')}
                        />
                        <label className="form-check-label" htmlFor="workConditionNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {hasWorkLimitingCondition === 'yes' && (
                <div className="mb-3">
                    <label className="form-label">Please explain:</label>
                    <textarea
                        className="form-control"
                        placeholder="Please explain"
                        rows="4"
                        value={workConditionDetails}
                        onChange={e => setWorkConditionDetails(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepSeven;
